// 防止输入负数、字符~~~~~~~~~~~~~~~~~~~~~~~~~~~


export const zeroHandler = (e) => {
    let tempStore = e.target.value;
    if (tempStore == 0) {
        e.target.value = 0.00001;
    }
};
export const filterNum = (e, minus = false, intOnly = false) => {
    let prohibit = ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9', '.']
    if (minus) {
        prohibit = ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9', '.', '-']
    }
    if (intOnly) {
        prohibit = ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9']
    }

    if (e.keyCode == 46 || e.keyCode == 8) {
        return
    } else if (!prohibit.includes(e.key)) {
        e.preventDefault();
    }
    // tempStore.value = e.target.value;
};

// 不正确的小数点检查~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
export const checkNum = (e, isZero = false) => {

    let obj = document.getElementById(e.target.id)
    let scale = 3

    const t = String(obj.value).charAt(0)


    // obj.value = obj.value.replace(/[^\u4E00-\u9FA5]/g, ""); //清除"数字"和"."以外的字符  keydown已经过滤了
    obj.value = obj.value.replace(/[^\d.]/g, "");  //j禁止输入中文
    obj.value = obj.value.replace(/^\./g, ""); //验证第一个字符是数字而不是其他字符
    obj.value = obj.value.replace(/\.{2,}/g, "."); //只保留第一个. 不能输入连续的.
    obj.value = obj.value.replace(".", "$#$").replace(/\./g, "").replace("$#$", ".");//清除后面的.
    var re = new RegExp("^(\\-)*(\\d+)\\.(\\d{" + scale + "}).*$");
    obj.value = obj.value.replace(re, '$1$2.$3'); //只能输入scale个小数

    if (!isZero) {
        if (obj.value == 0) {
            obj.value = 0.001;
            alert('不能输入0')
        }
    }

    if (t === '-') {
        obj.value = '-' + obj.value;
    }

    let event = document.createEvent('Event')
    event.initEvent('input', true, true)
    event.eventType = 'message'
    obj.dispatchEvent(event)
};